// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ACCELERATED_BLADE_TALENT: {
    id: 391275,
    name: 'Accelerated Blade',
    icon: 'ability_demonhunter_throwglaive',
    maxRanks: 1,
    entryIds: [112932],
    definitionIds: [{ id: 117937, specId: 577 }],
  },
  AGONIZING_FLAMES_TALENT: {
    id: 207548,
    name: 'Agonizing Flames',
    icon: 'achievment_raid_houroftwilight',
    maxRanks: 1,
    entryIds: [112887],
    definitionIds: [{ id: 117892, specId: 581 }],
  },
  ALDRACHI_DESIGN_TALENT: {
    id: 391409,
    name: 'Aldrachi Design',
    icon: 'inv_glaive_1h_artifactaldrochi_d_01dual',
    maxRanks: 1,
    entryIds: [112917],
    definitionIds: [{ id: 117922, specId: 1480 }],
  },
  ALDRACHI_TACTICS_TALENT: {
    id: 442683,
    name: 'Aldrachi Tactics',
    icon: 'ability_demonhunter_soulcleave2',
    maxRanks: 1,
    entryIds: [117511],
    definitionIds: [{ id: 122523, specId: 581 }],
  },
  ARMY_UNTO_ONESELF_TALENT: {
    id: 442714,
    name: 'Army Unto Oneself',
    icon: 'ability_warlock_avoidance',
    maxRanks: 1,
    entryIds: [117493],
    definitionIds: [{ id: 122505, specId: 581 }],
  },
  ART_OF_THE_GLAIVE_TALENT: {
    id: 442290,
    name: 'Art of the Glaive',
    icon: 'inv_ability_aldrachireaverdemonhunter_reaversglaive',
    maxRanks: 1,
    entryIds: [117512],
    definitionIds: [{ id: 122524, specId: 581 }],
  },
  ASCENDING_FLAME_TALENT: {
    id: 428603,
    name: 'Ascending Flame',
    icon: 'inv_helm_suncrown_d_01',
    maxRanks: 1,
    entryIds: [112875],
    definitionIds: [{ id: 117880, specId: 581 }],
  },
  AURA_OF_PAIN_TALENT: {
    id: 207347,
    name: 'Aura of Pain',
    icon: 'spell_fire_felimmolation',
    maxRanks: 1,
    entryIds: [112844],
    definitionIds: [{ id: 117849, specId: 1480 }],
  },
  A_FIRE_INSIDE_TALENT: {
    id: 427775,
    name: 'A Fire Inside',
    icon: 'ability_demonhunter_chaoticimprint_fire',
    maxRanks: 1,
    entryIds: [117741],
    definitionIds: [{ id: 122753, specId: 577 }],
  },
  BLADECRAFT_TALENT: {
    id: 1272153,
    name: 'Bladecraft',
    icon: 'ability_demonhunter_soulcleave3',
    maxRanks: 1,
    entryIds: [117503],
    definitionIds: [{ id: 122515, specId: 581 }],
  },
  BLAZING_PATH_TALENT: {
    id: 320416,
    name: 'Blazing Path',
    icon: 'ability_demonhunter_felrush',
    maxRanks: 1,
    entryIds: [117759],
    definitionIds: [{ id: 122771, specId: 1480 }],
  },
  BLIND_FOCUS_TALENT: {
    id: 1272364,
    name: 'Blind Focus',
    icon: 'inv_belt_leather_raiddemonhunter_r_01',
    maxRanks: 1,
    entryIds: [136031, 136607],
    definitionIds: [
      { id: 140786, specId: 577 },
      { id: 141380, specId: 1480 },
    ],
  },
  BLIND_FURY_TALENT: {
    id: 203550,
    name: 'Blind Fury',
    icon: 'ability_bosskilrogg_deadeye',
    maxRanks: 2,
    entryIds: [112949],
    definitionIds: [{ id: 117954, specId: 577 }],
  },
  BOUNCING_GLAIVES_TALENT: {
    id: 320386,
    name: 'Bouncing Glaives',
    icon: 'ability_demonhunter_throwglaive',
    maxRanks: 1,
    entryIds: [112841],
    definitionIds: [{ id: 117846, specId: 1480 }],
  },
  BROKEN_SPIRIT_TALENT: {
    id: 1272143,
    name: 'Broken Spirit',
    icon: 'ability_argus_soulbombdebufflarge',
    maxRanks: 1,
    entryIds: [136029],
    definitionIds: [{ id: 140784, specId: 581 }],
  },
  BURNING_ALIVE_TALENT: {
    id: 207739,
    name: 'Burning Alive',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [112873],
    definitionIds: [{ id: 117878, specId: 581 }],
  },
  BURNING_BLADES_TALENT: {
    id: 452408,
    name: 'Burning Blades',
    icon: 'inv_glaive_1h_artifactazgalor_d_02dual',
    maxRanks: 1,
    entryIds: [117502, 136610],
    definitionIds: [
      { id: 122514, specId: 577 },
      { id: 141383, specId: 1480 },
    ],
  },
  BURNING_BLOOD_TALENT: {
    id: 390213,
    name: 'Burning Blood',
    icon: 'ability_demonhunter_immolation',
    maxRanks: 1,
    entryIds: [112903],
    definitionIds: [{ id: 117908, specId: 581 }],
  },
  BURNING_HATRED_TALENT: {
    id: 320374,
    name: 'Burning Hatred',
    icon: 'ability_demonhunter_immolation',
    maxRanks: 1,
    entryIds: [112832],
    definitionIds: [{ id: 117837, specId: 577 }],
  },
  BURNING_WOUND_TALENT: {
    id: 391189,
    name: 'Burning Wound',
    icon: 'spell_fire_felhellfire',
    maxRanks: 1,
    entryIds: [112826],
    definitionIds: [{ id: 117831, specId: 577 }],
  },
  BURN_IT_OUT_TALENT: {
    id: 1266316,
    name: 'Burn It Out',
    icon: 'spell_fel_elementaldevastation',
    maxRanks: 1,
    entryIds: [112837],
    definitionIds: [{ id: 117842, specId: 1480 }],
  },
  CALAMITOUS_TALENT: {
    id: 1242495,
    name: 'Calamitous',
    icon: 'ability_argus_soulbombdebuffsmall',
    maxRanks: 1,
    entryIds: [136691],
    definitionIds: [{ id: 141463, specId: 1480 }],
  },
  CALCIFIED_SPIKES_TALENT: {
    id: 389720,
    name: 'Calcified Spikes',
    icon: 'ability_demonhunter_demonspikes',
    maxRanks: 1,
    entryIds: [112882],
    definitionIds: [{ id: 117887, specId: 581 }],
  },
  CATASTROPHE_TALENT: {
    id: 1253769,
    name: 'Catastrophe',
    icon: 'inv_netherportal',
    maxRanks: 1,
    entryIds: [135671],
    definitionIds: [{ id: 140427, specId: 1480 }],
  },
  CELESTIAL_ECHOES_TALENT: {
    id: 1253415,
    name: 'Celestial Echoes',
    icon: 'inv_polearm_2h_voidscythe_d_01',
    maxRanks: 1,
    entryIds: [135669],
    definitionIds: [{ id: 140425, specId: 1480 }],
  },
  CHAINS_OF_ANGER_TALENT: {
    id: 389715,
    name: 'Chains of Anger',
    icon: 'ability_demonhunter_sigilofchains',
    maxRanks: 1,
    entryIds: [112879],
    definitionIds: [{ id: 117884, specId: 581 }],
  },
  CHAMPION_OF_THE_GLAIVE_TALENT: {
    id: 429211,
    name: 'Champion of the Glaive',
    icon: 'inv_glaive_1h_battledungeon_c_01',
    maxRanks: 1,
    entryIds: [117768],
    definitionIds: [{ id: 122780, specId: 1480 }],
  },
  CHAOS_NOVA_TALENT: {
    id: 179057,
    name: 'Chaos Nova',
    icon: 'spell_fire_felfirenova',
    maxRanks: 1,
    entryIds: [112911, 134282],
    definitionIds: [
      { id: 117916, specId: 577 },
      { id: 139055, specId: 581 },
    ],
    furyCost: 25,
  },
  CHAOS_THEORY_TALENT: {
    id: 389687,
    name: 'Chaos Theory',
    icon: 'inv_glaive_1h_artifactaldrochi_d_03dual',
    maxRanks: 1,
    entryIds: [112958],
    definitionIds: [{ id: 117963, specId: 577 }],
  },
  CHAOTIC_DISPOSITION_TALENT: {
    id: 428492,
    name: 'Chaotic Disposition',
    icon: 'inv_inscription_tarotchaos',
    maxRanks: 2,
    entryIds: [117754],
    definitionIds: [{ id: 122766, specId: 577 }],
  },
  CHAOTIC_TRANSFORMATION_TALENT: {
    id: 388112,
    name: 'Chaotic Transformation',
    icon: 'ability_demonhunter_glide',
    maxRanks: 1,
    entryIds: [117765],
    definitionIds: [{ id: 122777, specId: 577 }],
  },
  CHARRED_FLESH_TALENT: {
    id: 336639,
    name: 'Charred Flesh',
    icon: 'ability_warlock_backdraft',
    maxRanks: 2,
    entryIds: [112877],
    definitionIds: [{ id: 117882, specId: 581 }],
  },
  CHARRED_WARBLADES_TALENT: {
    id: 213010,
    name: 'Charred Warblades',
    icon: 'spell_fire_incinerate',
    maxRanks: 1,
    entryIds: [112861],
    definitionIds: [{ id: 117866, specId: 1480 }],
  },
  COLLAPSING_STAR_TALENT: {
    id: 1221167,
    name: 'Collapsing Star',
    icon: 'inv_12_dh_void_ability_collapsingstar',
    maxRanks: 1,
    entryIds: [132281],
    definitionIds: [{ id: 137082, specId: 1480 }],
  },
  COLLECTIVE_ANGUISH_TALENT: {
    id: 390152,
    name: 'Collective Anguish',
    icon: 'artifactability_havocdemonhunter_anguishofthedeceiver',
    maxRanks: 1,
    entryIds: [134227],
    definitionIds: [{ id: 139005, specId: 577 }],
  },
  CONSUME_MAGIC_TALENT: {
    id: 278326,
    name: 'Consume Magic',
    icon: 'spell_misc_zandalari_council_soulswap',
    maxRanks: 1,
    entryIds: [112926],
    definitionIds: [{ id: 117931, specId: 1480 }],
  },
  CRITICAL_CHAOS_TALENT: {
    id: 320413,
    name: 'Critical Chaos',
    icon: 'inv_glaive_1h_battledungeon_c_02',
    maxRanks: 1,
    entryIds: [112951],
    definitionIds: [{ id: 117956, specId: 577 }],
  },
  CYCLE_OF_BINDING_TALENT: {
    id: 389718,
    name: 'Cycle of Binding',
    icon: 'ability_demonhunter_sigilofinquisition',
    maxRanks: 1,
    entryIds: [112878],
    definitionIds: [{ id: 117883, specId: 581 }],
  },
  CYCLE_OF_HATRED_TALENT: {
    id: 258887,
    name: 'Cycle of Hatred',
    icon: 'ability_ironmaidens_whirlofblood',
    maxRanks: 1,
    entryIds: [112955],
    definitionIds: [{ id: 117960, specId: 577 }],
  },
  DANCING_WITH_FATE_TALENT: {
    id: 389978,
    name: 'Dancing with Fate',
    icon: 'inv_polearm_1h_felfireraid_d_02',
    maxRanks: 2,
    entryIds: [112936],
    definitionIds: [{ id: 117941, specId: 577 }],
  },
  DARKGLARE_BOON_TALENT: {
    id: 389708,
    name: 'Darkglare Boon',
    icon: 'inv_jewelry_necklace_53',
    maxRanks: 1,
    entryIds: [112901],
    definitionIds: [{ id: 117906, specId: 581 }],
  },
  DARKNESS_TALENT: {
    id: 196718,
    name: 'Darkness',
    icon: 'ability_demonhunter_darkness',
    maxRanks: 1,
    entryIds: [112921],
    definitionIds: [{ id: 117926, specId: 1480 }],
  },
  DARK_MATTER_TALENT: {
    id: 1256307,
    name: 'Dark Matter',
    icon: 'inv_cosmicvoid_nova',
    maxRanks: 1,
    entryIds: [135662],
    definitionIds: [{ id: 140418, specId: 1480 }],
  },
  DASH_OF_CHAOS_TALENT: {
    id: 427794,
    name: 'Dash of Chaos',
    icon: 'inv_boots_cloth_35v3',
    maxRanks: 1,
    entryIds: [115245],
    definitionIds: [{ id: 120257, specId: 577 }],
  },
  DEFLECTING_DANCE_TALENT: {
    id: 427776,
    name: 'Deflecting Dance',
    icon: 'ability_ironmaidens_bladerush',
    maxRanks: 1,
    entryIds: [115246],
    definitionIds: [{ id: 120258, specId: 577 }],
  },
  DEMONIC_INSTINCT_TALENT: {
    id: 1247538,
    name: 'Demonic Instinct',
    icon: 'inv_12_dh_void_ability_predatorsthirst',
    maxRanks: 2,
    entryIds: [136690],
    definitionIds: [{ id: 141462, specId: 1480 }],
  },
  DEMONIC_INTENSITY_TALENT: {
    id: 452415,
    name: 'Demonic Intensity',
    icon: 'spell_warlock_demonicempowerment',
    maxRanks: 1,
    entryIds: [117498, 136617],
    definitionIds: [
      { id: 122510, specId: 577 },
      { id: 141390, specId: 1480 },
    ],
  },
  DEMONIC_RESILIENCE_TALENT: {
    id: 1266307,
    name: 'Demonic Resilience',
    icon: 'inv_summondemonictyrant',
    maxRanks: 1,
    entryIds: [117755],
    definitionIds: [{ id: 122767, specId: 1480 }],
  },
  DEMONIC_TALENT: {
    id: 213410,
    name: 'Demonic',
    icon: 'spell_shadow_demonform',
    maxRanks: 1,
    entryIds: [112831],
    definitionIds: [{ id: 117836, specId: 577 }],
  },
  DEMONSURGE_TALENT: {
    id: 452402,
    name: 'Demonsurge',
    icon: 'inv_ability_felscarreddemonhunter_demonsurge',
    maxRanks: 1,
    entryIds: [117514],
    definitionIds: [{ id: 122526, specId: 577 }],
  },
  DEMON_HIDE_TALENT: {
    id: 428241,
    name: 'Demon Hide',
    icon: 'misc_legionfall_demonhunter',
    maxRanks: 1,
    entryIds: [112938],
    definitionIds: [{ id: 117943, specId: 577 }],
  },
  DEMON_MUZZLE_TALENT: {
    id: 1266329,
    name: 'Demon Muzzle',
    icon: 'spell_warlock_demonicservitude',
    maxRanks: 1,
    entryIds: [112838],
    definitionIds: [{ id: 117843, specId: 1480 }],
  },
  DESPERATE_INSTINCTS_TALENT: {
    id: 205411,
    name: 'Desperate Instincts',
    icon: 'spell_shadow_manafeed',
    maxRanks: 1,
    entryIds: [115248],
    definitionIds: [{ id: 120260, specId: 577 }],
  },
  DEVOURERS_BITE_TALENT: {
    id: 1240201,
    name: "Devourer's Bite",
    icon: 'inv_12_dh_void_ability_devourerbite',
    maxRanks: 1,
    entryIds: [136692],
    definitionIds: [{ id: 141464, specId: 1480 }],
  },
  DEVOURERS_EDGE_TALENT: {
    id: 1244222,
    name: "Devourer's Edge",
    icon: 'inv_12_dh_void_ability_empoweredreap',
    maxRanks: 2,
    entryIds: [133538],
    definitionIds: [{ id: 138324, specId: 1480 }],
  },
  DISRUPTING_FURY_TALENT: {
    id: 183782,
    name: 'Disrupting Fury',
    icon: 'ability_demonhunter_consumemagic',
    maxRanks: 1,
    entryIds: [112848],
    definitionIds: [{ id: 117853, specId: 1480 }],
  },
  DOOMSAYER_TALENT: {
    id: 1253676,
    name: 'Doomsayer',
    icon: 'inv_shadowflame_buff',
    maxRanks: 1,
    entryIds: [135668],
    definitionIds: [{ id: 140424, specId: 1480 }],
  },
  DOWN_IN_FLAMES_TALENT: {
    id: 389732,
    name: 'Down in Flames',
    icon: 'ability_demonhunter_fierybrand',
    maxRanks: 1,
    entryIds: [112876],
    definitionIds: [{ id: 117881, specId: 581 }],
  },
  DUTY_ETERNAL_TALENT: {
    id: 1246562,
    name: 'Duty Eternal',
    icon: 'inv_12_voiddh_ability_voidblade',
    maxRanks: 1,
    entryIds: [134275],
    definitionIds: [{ id: 139048, specId: 1480 }],
  },
  EMPTINESS_TALENT: {
    id: 1242492,
    name: 'Emptiness',
    icon: 'inv_cosmicvoid_buff',
    maxRanks: 1,
    entryIds: [133512],
    definitionIds: [{ id: 138298, specId: 1480 }],
  },
  ENDURING_TORMENT_TALENT: {
    id: 452410,
    name: 'Enduring Torment',
    icon: 'spell_fire_felimmolation',
    maxRanks: 1,
    entryIds: [117513, 136615],
    definitionIds: [
      { id: 122525, specId: 577 },
      { id: 141388, specId: 1480 },
    ],
  },
  ENTROPY_TALENT: {
    id: 1261684,
    name: 'Entropy',
    icon: 'inv_112_raidtrinkets_voidprism',
    maxRanks: 1,
    entryIds: [133511],
    definitionIds: [{ id: 138297, specId: 1480 }],
  },
  ERADICATE_TALENT: {
    id: 1226033,
    name: 'Eradicate',
    icon: 'inv_12_dh_void_ability_eradicate',
    maxRanks: 1,
    entryIds: [132287],
    definitionIds: [{ id: 137088, specId: 1480 }],
  },
  ERRATIC_FELHEART_TALENT: {
    id: 391397,
    name: 'Erratic Felheart',
    icon: 'inv_archaeology_70_crystallineeyeofundravius',
    maxRanks: 2,
    entryIds: [112914],
    definitionIds: [{ id: 117919, specId: 1480 }],
  },
  ESSENCE_BREAK_TALENT: {
    id: 258860,
    name: 'Essence Break',
    icon: 'spell_shadow_ritualofsacrifice',
    maxRanks: 1,
    entryIds: [112956],
    definitionIds: [{ id: 117961, specId: 577 }],
  },
  ETERNAL_HUNT_1_HAVOC_TALENT: {
    id: 1270898,
    name: 'Eternal Hunt',
    icon: 'inv12_apextalent_demonhunter_eternalhunt',
    maxRanks: 1,
    entryIds: [137049],
    definitionIds: [{ id: 141812, specId: 577 }],
  },
  ETERNAL_HUNT_2_HAVOC_TALENT: {
    id: 1270900,
    name: 'Eternal Hunt',
    icon: 'inv12_apextalent_demonhunter_eternalhunt',
    maxRanks: 2,
    entryIds: [137048],
    definitionIds: [{ id: 141811, specId: 577 }],
  },
  ETERNAL_HUNT_3_HAVOC_TALENT: {
    id: 1270901,
    name: 'Eternal Hunt',
    icon: 'inv12_apextalent_demonhunter_eternalhunt',
    maxRanks: 1,
    entryIds: [137047],
    definitionIds: [{ id: 141810, specId: 577 }],
  },
  EVASIVE_ACTION_TALENT: {
    id: 444926,
    name: 'Evasive Action',
    icon: 'ability_demonhunter_vengefulretreat',
    maxRanks: 1,
    entryIds: [117508],
    definitionIds: [{ id: 122520, specId: 581 }],
  },
  EXERGY_TALENT: {
    id: 206476,
    name: 'Exergy',
    icon: 'ability_foundryraid_demolition',
    maxRanks: 1,
    entryIds: [112943],
    definitionIds: [{ id: 117948, specId: 577 }],
  },
  EYE_BEAM_TALENT: {
    id: 198013,
    name: 'Eye Beam',
    icon: 'ability_demonhunter_eyebeam',
    maxRanks: 1,
    entryIds: [112939],
    definitionIds: [{ id: 117944, specId: 577 }],
    furyCost: 30,
  },
  FALLOUT_TALENT: {
    id: 227174,
    name: 'Fallout',
    icon: 'spell_volatilefiregreen',
    maxRanks: 1,
    entryIds: [112888],
    definitionIds: [{ id: 117893, specId: 581 }],
  },
  FEAST_OF_SOULS_DEVOURER_TALENT: {
    id: 1237270,
    name: 'Feast of Souls',
    icon: 'inv_12_dh_void_ability_firstofsouls',
    maxRanks: 1,
    entryIds: [132285],
    definitionIds: [{ id: 137086, specId: 1480 }],
  },
  FEAST_OF_SOULS_VENGEANCE_TALENT: {
    id: 207697,
    name: 'Feast of Souls',
    icon: 'spell_shadow_soulleech',
    maxRanks: 1,
    entryIds: [112884],
    definitionIds: [{ id: 117889, specId: 581 }],
  },
  FEED_THE_DEMON_TALENT: {
    id: 218612,
    name: 'Feed the Demon',
    icon: 'spell_warlock_demonicempowerment',
    maxRanks: 1,
    entryIds: [112881],
    definitionIds: [{ id: 117886, specId: 581 }],
  },
  FELBLADE_TALENT: {
    id: 232893,
    name: 'Felblade',
    icon: 'ability_demonhunter_felblade',
    maxRanks: 1,
    entryIds: [112928, 134271],
    definitionIds: [
      { id: 117933, specId: 577 },
      { id: 139044, specId: 581 },
    ],
  },
  FELBOUND_TALENT: {
    id: 1266762,
    name: 'Felbound',
    icon: 'ability_demonhunter_doublejump',
    maxRanks: 1,
    entryIds: [112923, 134281],
    definitionIds: [
      { id: 117928, specId: 577 },
      { id: 139054, specId: 581 },
    ],
  },
  FELFIRE_FIST_TALENT: {
    id: 389724,
    name: 'Felfire Fist',
    icon: 'inv12_ability_demonhunter_felfirefists',
    maxRanks: 1,
    entryIds: [112866],
    definitionIds: [{ id: 117871, specId: 581 }],
  },
  FELFIRE_HASTE_TALENT: {
    id: 389846,
    name: 'Felfire Haste',
    icon: 'inv_boots_cloth_35v4',
    maxRanks: 1,
    entryIds: [112850],
    definitionIds: [{ id: 117855, specId: 1480 }],
  },
  FEL_DEVASTATION_TALENT: {
    id: 212084,
    name: 'Fel Devastation',
    icon: 'ability_demonhunter_feldevastation',
    maxRanks: 1,
    entryIds: [112908],
    definitionIds: [{ id: 117913, specId: 581 }],
    furyCost: 50,
  },
  FEL_FLAME_FORTIFICATION_TALENT: {
    id: 389705,
    name: 'Fel Flame Fortification',
    icon: 'spell_fire_felfire',
    maxRanks: 1,
    entryIds: [112868],
    definitionIds: [{ id: 117873, specId: 581 }],
  },
  FIERY_BRAND_TALENT: {
    id: 204021,
    name: 'Fiery Brand',
    icon: 'ability_demonhunter_fierybrand',
    maxRanks: 1,
    entryIds: [112864],
    definitionIds: [{ id: 117869, specId: 581 }],
  },
  FIERY_DEMISE_TALENT: {
    id: 389220,
    name: 'Fiery Demise',
    icon: 'ability_demonhunter_fierybrand',
    maxRanks: 2,
    entryIds: [112872],
    definitionIds: [{ id: 117877, specId: 581 }],
  },
  FINAL_BREATH_TALENT: {
    id: 1266500,
    name: 'Final Breath',
    icon: 'spell_fire_felflamebreath',
    maxRanks: 1,
    entryIds: [136501],
    definitionIds: [{ id: 141274, specId: 1480 }],
  },
  FINAL_HOUR_TALENT: {
    id: 1253805,
    name: 'Final Hour',
    icon: 'inv_10_worlddroplevelingoptionalreagent_relics_hourglass_color1',
    maxRanks: 1,
    entryIds: [135663],
    definitionIds: [{ id: 140419, specId: 1480 }],
  },
  FIRST_BLOOD_TALENT: {
    id: 206416,
    name: 'First Blood',
    icon: 'ability_deathwing_bloodcorruption_death',
    maxRanks: 1,
    entryIds: [112834],
    definitionIds: [{ id: 117839, specId: 577 }],
  },
  FIRST_IN_LAST_OUT_TALENT: {
    id: 1266497,
    name: 'First In, Last Out',
    icon: 'ability_demonhunter_demonictrample',
    maxRanks: 1,
    entryIds: [117758],
    definitionIds: [{ id: 122770, specId: 1480 }],
  },
  FLAMEBOUND_TALENT: {
    id: 452413,
    name: 'Flamebound',
    icon: 'spell_fire_felflamering',
    maxRanks: 1,
    entryIds: [124009, 136614],
    definitionIds: [
      { id: 128847, specId: 577 },
      { id: 141387, specId: 1480 },
    ],
  },
  FOCUSED_CLEAVE_TALENT: {
    id: 343207,
    name: 'Focused Cleave',
    icon: 'ability_demonhunter_soulcleave',
    maxRanks: 1,
    entryIds: [112891],
    definitionIds: [{ id: 117896, specId: 581 }],
  },
  FOCUSED_HATRED_TALENT: {
    id: 452405,
    name: 'Focused Hatred',
    icon: 'ability_demonhunter_illidansgrasp',
    maxRanks: 1,
    entryIds: [117515, 136612],
    definitionIds: [
      { id: 122527, specId: 577 },
      { id: 141385, specId: 1480 },
    ],
  },
  FOCUSED_IRE_TALENT: {
    id: 1266296,
    name: 'Focused Ire',
    icon: 'ability_bossfellord_felspike',
    maxRanks: 1,
    entryIds: [117767],
    definitionIds: [{ id: 122779, specId: 1480 }],
  },
  FOCUSED_RAY_TALENT: {
    id: 1240203,
    name: 'Focused Ray',
    icon: 'inv_cosmicvoid_beam',
    maxRanks: 1,
    entryIds: [133110],
    definitionIds: [{ id: 137896, specId: 1480 }],
  },
  FRAILTY_TALENT: {
    id: 389958,
    name: 'Frailty',
    icon: 'inv_icon_shadowcouncilorb_purple',
    maxRanks: 1,
    entryIds: [112893],
    definitionIds: [{ id: 117898, specId: 581 }],
  },
  FURIOUS_GAZE_TALENT: {
    id: 343311,
    name: 'Furious Gaze',
    icon: 'ability_demonhunter_eyebeam',
    maxRanks: 1,
    entryIds: [112948],
    definitionIds: [{ id: 117953, specId: 577 }],
  },
  FURIOUS_TALENT: {
    id: 1266326,
    name: 'Furious',
    icon: 'ability_warlock_shadowfurytga',
    maxRanks: 1,
    entryIds: [117762],
    definitionIds: [{ id: 122774, specId: 1480 }],
  },
  FURIOUS_THROWS_TALENT: {
    id: 393029,
    name: 'Furious Throws',
    icon: 'inv_glaive_1h_npc_d_01',
    maxRanks: 1,
    entryIds: [115244],
    definitionIds: [{ id: 120256, specId: 577 }],
  },
  FURY_OF_THE_ALDRACHI_TALENT: {
    id: 442718,
    name: 'Fury of the Aldrachi',
    icon: 'spell_fire_felflamestrike',
    maxRanks: 1,
    entryIds: [117495],
    definitionIds: [{ id: 122519, specId: 581 }],
  },
  GIFT_OF_THE_VOID_TALENT: {
    id: 1272847,
    name: 'Gift of the Void',
    icon: 'ability_demonhunter_reversemagic',
    maxRanks: 1,
    entryIds: [133111],
    definitionIds: [{ id: 137897, specId: 1480 }],
  },
  GLAIVE_TEMPEST_TALENT: {
    id: 1244557,
    name: 'Glaive Tempest',
    icon: 'inv_glaive_1h_artifactazgalor_d_06dual',
    maxRanks: 1,
    entryIds: [134203],
    definitionIds: [{ id: 138983, specId: 577 }],
  },
  GROWING_INFERNO_TALENT: {
    id: 390158,
    name: 'Growing Inferno',
    icon: 'spell_fel_incinerate',
    maxRanks: 1,
    entryIds: [112825],
    definitionIds: [{ id: 117830, specId: 577 }],
  },
  GUILE_TALENT: {
    id: 1223171,
    name: 'Guile',
    icon: 'spell_shadow_demonform',
    maxRanks: 1,
    entryIds: [132288],
    definitionIds: [{ id: 137089, specId: 1480 }],
  },
  HARNESS_THE_COSMOS_TALENT: {
    id: 1279247,
    name: 'Harness the Cosmos',
    icon: 'inv_cosmicvoid_orb',
    maxRanks: 1,
    entryIds: [136810],
    definitionIds: [{ id: 141573, specId: 1480 }],
  },
  HUNGERING_SLASH_TALENT: {
    id: 1239519,
    name: 'Hungering Slash',
    icon: 'inv_12_dh_void_ability_reapersslice',
    maxRanks: 1,
    entryIds: [133531],
    definitionIds: [{ id: 138317, specId: 1480 }],
  },
  ILLIDARI_KNOWLEDGE_TALENT: {
    id: 389696,
    name: 'Illidari Knowledge',
    icon: 'spell_mage_overpowered',
    maxRanks: 2,
    entryIds: [112846],
    definitionIds: [{ id: 117851, specId: 1480 }],
  },
  IMPENDING_APOCALYPSE_TALENT: {
    id: 1227707,
    name: 'Impending Apocalypse',
    icon: 'inv_12_dh_void_ability_impendingapocalypse',
    maxRanks: 1,
    entryIds: [132283],
    definitionIds: [{ id: 137084, specId: 1480 }],
  },
  IMPRISON_TALENT: {
    id: 217832,
    name: 'Imprison',
    icon: 'ability_demonhunter_imprison',
    maxRanks: 1,
    entryIds: [112927],
    definitionIds: [{ id: 117932, specId: 1480 }],
  },
  IMPROVED_CHAOS_STRIKE_TALENT: {
    id: 343206,
    name: 'Improved Chaos Strike',
    icon: 'ability_demonhunter_chaosstrike',
    maxRanks: 1,
    entryIds: [112953],
    definitionIds: [{ id: 117958, specId: 577 }],
  },
  IMPROVED_CONSUME_TALENT: {
    id: 1272817,
    name: 'Improved Consume',
    icon: 'inv_12_dh_void_ability_feast',
    maxRanks: 1,
    entryIds: [134330],
    definitionIds: [{ id: 139102, specId: 1480 }],
  },
  IMPROVED_DISRUPT_TALENT: {
    id: 320361,
    name: 'Improved Disrupt',
    icon: 'ability_demonhunter_consumemagic',
    maxRanks: 1,
    entryIds: [112849],
    definitionIds: [{ id: 117854, specId: 1480 }],
  },
  IMPROVED_SIGIL_OF_MISERY_TALENT: {
    id: 320418,
    name: 'Improved Sigil of Misery',
    icon: 'ability_demonhunter_sigilofmisery',
    maxRanks: 1,
    entryIds: [112858],
    definitionIds: [{ id: 117863, specId: 1480 }],
  },
  IMPROVED_SOUL_RENDING_TALENT: {
    id: 452407,
    name: 'Improved Soul Rending',
    icon: 'ability_demonhunter_soulcleave2',
    maxRanks: 1,
    entryIds: [124010, 136618],
    definitionIds: [
      { id: 128848, specId: 577 },
      { id: 141391, specId: 1480 },
    ],
  },
  INCISIVE_BLADE_TALENT: {
    id: 442492,
    name: 'Incisive Blade',
    icon: 'ability_dualwieldspecialization',
    maxRanks: 1,
    entryIds: [117492],
    definitionIds: [{ id: 122504, specId: 581 }],
  },
  INCORRUPTIBLE_SPIRIT_TALENT: {
    id: 442736,
    name: 'Incorruptible Spirit',
    icon: 'spell_nzinsanity_chasedbyshadows',
    maxRanks: 1,
    entryIds: [123046],
    definitionIds: [{ id: 127927, specId: 581 }],
  },
  INERTIA_TALENT: {
    id: 427640,
    name: 'Inertia',
    icon: 'inv_10_inscription3_pigments_black',
    maxRanks: 1,
    entryIds: [117744],
    definitionIds: [{ id: 122756, specId: 577 }],
  },
  INFERNAL_ARMOR_TALENT: {
    id: 320331,
    name: 'Infernal Armor',
    icon: 'ability_demonhunter_immolation',
    maxRanks: 2,
    entryIds: [112924],
    definitionIds: [{ id: 117929, specId: 1480 }],
  },
  INITIATIVE_TALENT: {
    id: 388108,
    name: 'Initiative',
    icon: 'ability_rogue_surpriseattack',
    maxRanks: 1,
    entryIds: [112950],
    definitionIds: [{ id: 117955, specId: 577 }],
  },
  INNER_DEMON_TALENT: {
    id: 389693,
    name: 'Inner Demon',
    icon: 'ability_demonhunter_glide',
    maxRanks: 1,
    entryIds: [112947],
    definitionIds: [{ id: 117952, specId: 577 }],
  },
  INTERNAL_STRUGGLE_TALENT: {
    id: 393822,
    name: 'Internal Struggle',
    icon: 'ability_warlock_demonicpower',
    maxRanks: 1,
    entryIds: [112845],
    definitionIds: [{ id: 117850, specId: 1480 }],
  },
  ISOLATED_PREY_TALENT: {
    id: 388113,
    name: 'Isolated Prey',
    icon: 'spell_shadow_shadesofdarkness',
    maxRanks: 1,
    entryIds: [112959],
    definitionIds: [{ id: 117964, specId: 577 }],
  },
  KEEN_EDGE_TALENT: {
    id: 1272138,
    name: 'Keen Edge',
    icon: 'inv_glaive_1h_tyrande_d_01',
    maxRanks: 1,
    entryIds: [136028],
    definitionIds: [{ id: 140783, specId: 581 }],
  },
  KEEN_ENGAGEMENT_TALENT: {
    id: 442497,
    name: 'Keen Engagement',
    icon: 'ability_warlock_shadowfurytga',
    maxRanks: 1,
    entryIds: [117507],
    definitionIds: [{ id: 122507, specId: 581 }],
  },
  KNOW_YOUR_ENEMY_TALENT: {
    id: 388118,
    name: 'Know Your Enemy',
    icon: 'ability_demonhunter_eyeofleotheras',
    maxRanks: 2,
    entryIds: [112957],
    definitionIds: [{ id: 117962, specId: 577 }],
  },
  LAST_RESORT_TALENT: {
    id: 209258,
    name: 'Last Resort',
    icon: 'inv_glaive_1h_artifactaldorchi_d_06',
    maxRanks: 1,
    entryIds: [112895],
    definitionIds: [{ id: 117900, specId: 581 }],
  },
  LIVE_BY_THE_GLAIVE_TALENT: {
    id: 428607,
    name: 'Live by the Glaive',
    icon: 'inv_sword_108',
    maxRanks: 1,
    entryIds: [117761],
    definitionIds: [{ id: 122773, specId: 1480 }],
  },
  LONG_NIGHT_TALENT: {
    id: 389781,
    name: 'Long Night',
    icon: 'spell_fire_twilightimmolation',
    maxRanks: 1,
    entryIds: [112920],
    definitionIds: [{ id: 117925, specId: 1480 }],
  },
  LOST_IN_DARKNESS_TALENT: {
    id: 389849,
    name: 'Lost in Darkness',
    icon: 'inv_pet_inquisitoreye',
    maxRanks: 1,
    entryIds: [112860],
    definitionIds: [{ id: 117865, specId: 1480 }],
  },
  MASS_ACCELERATION_TALENT: {
    id: 1256295,
    name: 'Mass Acceleration',
    icon: 'inv_nullstone_cosmicvoid',
    maxRanks: 1,
    entryIds: [135665],
    definitionIds: [{ id: 140421, specId: 1480 }],
  },
  MASTER_OF_THE_GLAIVE_TALENT: {
    id: 389763,
    name: 'Master of the Glaive',
    icon: 'inv_glaive_1h_demonhunter_a_01',
    maxRanks: 1,
    entryIds: [112912],
    definitionIds: [{ id: 117917, specId: 1480 }],
  },
  METEORIC_FALL_TALENT: {
    id: 1253391,
    name: 'Meteoric Fall',
    icon: 'ability_socererking_arcanereplication',
    maxRanks: 1,
    entryIds: [135664],
    definitionIds: [{ id: 140420, specId: 1480 }],
  },
  METEORIC_RISE_TALENT: {
    id: 1253377,
    name: 'Meteoric Rise',
    icon: 'ability_socererking_arcanefortification',
    maxRanks: 1,
    entryIds: [135673],
    definitionIds: [{ id: 140429, specId: 1480 }],
  },
  MIDNIGHT_1_DEVOURER_TALENT: {
    id: 1242486,
    name: 'Midnight',
    icon: 'inv12_apextalent_demonhunter_midnight',
    maxRanks: 1,
    entryIds: [137016],
    definitionIds: [{ id: 141779, specId: 1480 }],
  },
  MIDNIGHT_2_DEVOURER_TALENT: {
    id: 1250088,
    name: 'Midnight',
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    maxRanks: 2,
    entryIds: [137015],
    definitionIds: [{ id: 141778, specId: 1480 }],
  },
  MIDNIGHT_3_DEVOURER_TALENT: {
    id: 1250094,
    name: 'Midnight',
    icon: 'ability_argus_edgeofobliteration',
    maxRanks: 1,
    entryIds: [137014],
    definitionIds: [{ id: 141777, specId: 1480 }],
  },
  MOMENT_OF_CRAVING_TALENT: {
    id: 1238488,
    name: 'Moment of Craving',
    icon: 'inv_12_dh_void_ability_momentofcraving',
    maxRanks: 1,
    entryIds: [133106],
    definitionIds: [{ id: 137892, specId: 1480 }],
  },
  MONSTER_RISING_TALENT: {
    id: 452414,
    name: 'Monster Rising',
    icon: 'ability_warlock_demonicpower',
    maxRanks: 1,
    entryIds: [117506, 136608],
    definitionIds: [
      { id: 122518, specId: 577 },
      { id: 141381, specId: 1480 },
    ],
  },
  MORTAL_DANCE_TALENT: {
    id: 328725,
    name: 'Mortal Dance',
    icon: 'ability_demonhunter_vengefulretreat',
    maxRanks: 1,
    entryIds: [117743],
    definitionIds: [{ id: 122755, specId: 577 }],
  },
  OTHERWORLDLY_FOCUS_TALENT: {
    id: 1253817,
    name: 'Otherworldly Focus',
    icon: 'inv_babyvoidwalker_blue',
    maxRanks: 1,
    entryIds: [135661],
    definitionIds: [{ id: 140417, specId: 1480 }],
  },
  PAINBRINGER_TALENT: {
    id: 207387,
    name: 'Painbringer',
    icon: 'artifactability_vengeancedemonhunter_painbringer',
    maxRanks: 2,
    entryIds: [112892],
    definitionIds: [{ id: 117897, specId: 581 }],
  },
  PATH_TO_OBLIVION_TALENT: {
    id: 1253399,
    name: 'Path to Oblivion',
    icon: 'ability_socererking_arcaneacceleration',
    maxRanks: 1,
    entryIds: [135666],
    definitionIds: [{ id: 140422, specId: 1480 }],
  },
  PERFECTLY_BALANCED_GLAIVE_TALENT: {
    id: 320387,
    name: 'Perfectly Balanced Glaive',
    icon: 'ability_demonhunter_throwglaive',
    maxRanks: 1,
    entryIds: [112886],
    definitionIds: [{ id: 117891, specId: 581 }],
  },
  PHASE_SHIFT_TALENT: {
    id: 1256245,
    name: 'Phase Shift',
    icon: 'ability_demonhunter_blur',
    maxRanks: 1,
    entryIds: [135670],
    definitionIds: [{ id: 140426, specId: 1480 }],
  },
  PITCH_BLACK_TALENT: {
    id: 389783,
    name: 'Pitch Black',
    icon: 'sha_spell_warlock_demonsoul',
    maxRanks: 1,
    entryIds: [112919],
    definitionIds: [{ id: 117924, specId: 1480 }],
  },
  PREDATORS_THIRST_TALENT: {
    id: 1215617,
    name: "Predator's Thirst",
    icon: 'inv_12_dh_void_ability_consume',
    maxRanks: 1,
    entryIds: [133107],
    definitionIds: [{ id: 137893, specId: 1480 }],
  },
  PREEMPTIVE_STRIKE_TALENT: {
    id: 444997,
    name: 'Preemptive Strike',
    icon: 'ability_rogue_focusedattacks',
    maxRanks: 1,
    entryIds: [122422],
    definitionIds: [{ id: 127322, specId: 581 }],
  },
  PURSUIT_OF_ANGRINESS_TALENT: {
    id: 452404,
    name: 'Pursuit of Angriness',
    icon: 'ability_felarakkoa_focusedblast',
    maxRanks: 1,
    entryIds: [124011, 136619],
    definitionIds: [
      { id: 128849, specId: 577 },
      { id: 141392, specId: 1480 },
    ],
  },
  PURSUIT_TALENT: {
    id: 320654,
    name: 'Pursuit',
    icon: 'ability_demonhunter_infernalstrike2',
    maxRanks: 1,
    entryIds: [112851],
    definitionIds: [{ id: 117856, specId: 1480 }],
  },
  QUICKENED_SIGILS_TALENT: {
    id: 209281,
    name: 'Quickened Sigils',
    icon: 'ability_demonhunter_concentratedsigils',
    maxRanks: 1,
    entryIds: [112906],
    definitionIds: [{ id: 117911, specId: 581 }],
  },
  RAGEFIRE_TALENT: {
    id: 388107,
    name: 'Ragefire',
    icon: 'spell_fire_fireballgreen',
    maxRanks: 1,
    entryIds: [112827],
    definitionIds: [{ id: 117832, specId: 577 }],
  },
  REAVERS_MARK_TALENT: {
    id: 442679,
    name: "Reaver's Mark",
    icon: 'ability_hunter_harass',
    maxRanks: 1,
    entryIds: [117500],
    definitionIds: [{ id: 122512, specId: 581 }],
  },
  RELENTLESS_ONSLAUGHT_TALENT: {
    id: 389977,
    name: 'Relentless Onslaught',
    icon: 'ability_demonhunter_soulcleave2',
    maxRanks: 1,
    entryIds: [112933],
    definitionIds: [{ id: 117938, specId: 577 }],
  },
  REMORSELESS_TALENT: {
    id: 1266328,
    name: 'Remorseless',
    icon: 'inv_glaive_1h_npc_d_02',
    maxRanks: 1,
    entryIds: [112839],
    definitionIds: [{ id: 117844, specId: 1480 }],
  },
  RETALIATION_TALENT: {
    id: 389729,
    name: 'Retaliation',
    icon: 'ability_demonhunter_demonspikes2',
    maxRanks: 1,
    entryIds: [112865],
    definitionIds: [{ id: 117870, specId: 581 }],
  },
  REVEL_IN_PAIN_TALENT: {
    id: 343014,
    name: 'Revel in Pain',
    icon: 'ability_bossfelmagnaron_handempowered',
    maxRanks: 1,
    entryIds: [112871],
    definitionIds: [{ id: 117876, specId: 581 }],
  },
  ROARING_FIRE_TALENT: {
    id: 391178,
    name: 'Roaring Fire',
    icon: 'spell_fire_felflamering',
    maxRanks: 1,
    entryIds: [112905],
    definitionIds: [{ id: 117910, specId: 581 }],
  },
  ROLLING_TORMENT_TALENT: {
    id: 1244237,
    name: 'Rolling Torment',
    icon: 'inv_cosmicvoid_debuff',
    maxRanks: 1,
    entryIds: [136693],
    definitionIds: [{ id: 141465, specId: 1480 }],
  },
  RUINOUS_BULWARK_TALENT: {
    id: 326853,
    name: 'Ruinous Bulwark',
    icon: 'ability_demonhunter_feldevastation',
    maxRanks: 1,
    entryIds: [112880],
    definitionIds: [{ id: 117885, specId: 581 }],
  },
  SCARS_OF_SUFFERING_TALENT: {
    id: 428232,
    name: 'Scars of Suffering',
    icon: 'spell_fire_felimmolation',
    maxRanks: 1,
    entryIds: [112823],
    definitionIds: [{ id: 117828, specId: 577 }],
  },
  SCREAMING_BRUTALITY_TALENT: {
    id: 1220506,
    name: 'Screaming Brutality',
    icon: 'inv_misc_magtheridonshead',
    maxRanks: 1,
    entryIds: [112828],
    definitionIds: [{ id: 117833, specId: 577 }],
  },
  SCYTHES_EMBRACE_TALENT: {
    id: 1246558,
    name: "Scythe's Embrace",
    icon: 'inv_12_dh_void_ability_voidreaper',
    maxRanks: 1,
    entryIds: [134279],
    definitionIds: [{ id: 139052, specId: 1480 }],
  },
  SECOND_HELPING_TALENT: {
    id: 1239537,
    name: 'Second Helping',
    icon: 'inv_polearm_2h_voidscythe_d_01',
    maxRanks: 1,
    entryIds: [136499],
    definitionIds: [{ id: 141272, specId: 1480 }],
  },
  SERRATED_GLAIVE_TALENT: {
    id: 390154,
    name: 'Serrated Glaive',
    icon: 'inv_glaive_1h_artifactaldrochi_d_03dual',
    maxRanks: 1,
    entryIds: [112934],
    definitionIds: [{ id: 117939, specId: 577 }],
  },
  SET_FIRE_TO_THE_PAIN_TALENT: {
    id: 452406,
    name: 'Set Fire to the Pain',
    icon: 'ability_demonhunter_empowerwards',
    maxRanks: 1,
    entryIds: [117496, 136620],
    definitionIds: [
      { id: 122508, specId: 577 },
      { id: 141393, specId: 1480 },
    ],
  },
  SHATTERED_DESTINY_TALENT: {
    id: 388116,
    name: 'Shattered Destiny',
    icon: 'achievement_boss_triumvirate_darknaaru',
    maxRanks: 1,
    entryIds: [112954],
    definitionIds: [{ id: 117959, specId: 577 }],
  },
  SHATTERED_RESTORATION_TALENT: {
    id: 389824,
    name: 'Shattered Restoration',
    icon: 'ability_warlock_soulsiphon',
    maxRanks: 1,
    entryIds: [112863],
    definitionIds: [{ id: 117868, specId: 1480 }],
  },
  SIGIL_OF_CHAINS_TALENT: {
    id: 202138,
    name: 'Sigil of Chains',
    icon: 'ability_demonhunter_sigilofchains',
    maxRanks: 1,
    entryIds: [112867],
    definitionIds: [{ id: 117872, specId: 581 }],
  },
  SIGIL_OF_MISERY_TALENT: {
    id: 207684,
    name: 'Sigil of Misery',
    icon: 'ability_demonhunter_sigilofmisery',
    maxRanks: 1,
    entryIds: [112859],
    definitionIds: [{ id: 117864, specId: 1480 }],
  },
  SIGIL_OF_SILENCE_TALENT: {
    id: 202137,
    name: 'Sigil of Silence',
    icon: 'ability_demonhunter_sigilofsilence',
    maxRanks: 1,
    entryIds: [112904],
    definitionIds: [{ id: 117909, specId: 581 }],
  },
  SIGIL_OF_SPITE_TALENT: {
    id: 390163,
    name: 'Sigil of Spite',
    icon: 'inv_ability_demonhunter_elysiandecree',
    maxRanks: 1,
    entryIds: [112894],
    definitionIds: [{ id: 117899, specId: 581 }],
  },
  SINGED_SPIRIT_TALENT: {
    id: 1272832,
    name: 'Singed Spirit',
    icon: 'inv_11_0_misc_candlekobold_color3',
    maxRanks: 1,
    entryIds: [134148],
    definitionIds: [{ id: 138928, specId: 1480 }],
  },
  SINGULAR_STRIKES_TALENT: {
    id: 1272770,
    name: 'Singular Strikes',
    icon: 'inv_12_dh_void_ability_scythethrow',
    maxRanks: 1,
    entryIds: [136695],
    definitionIds: [{ id: 141467, specId: 1480 }],
  },
  SOULCRUSH_TALENT: {
    id: 389985,
    name: 'Soulcrush',
    icon: 'inv_icon_shadowcouncilorb_purple',
    maxRanks: 1,
    entryIds: [112896],
    definitionIds: [{ id: 117901, specId: 581 }],
  },
  SOULFORGED_BLADES_TALENT: {
    id: 1272432,
    name: 'Soulforged Blades',
    icon: 'inv12_ability_deathknight_frostscythe',
    maxRanks: 1,
    entryIds: [136696],
    definitionIds: [{ id: 141468, specId: 1480 }],
  },
  SOULMONGER_TALENT: {
    id: 389711,
    name: 'Soulmonger',
    icon: 'ability_demonhunter_shatteredsouls',
    maxRanks: 1,
    entryIds: [112889],
    definitionIds: [{ id: 117894, specId: 581 }],
  },
  SOULSCAR_TALENT: {
    id: 388106,
    name: 'Soulscar',
    icon: 'ability_demonhunter_bloodlet',
    maxRanks: 1,
    entryIds: [117764],
    definitionIds: [{ id: 122776, specId: 577 }],
  },
  SOULSHAPER_TALENT: {
    id: 1238739,
    name: 'Soulshaper',
    icon: 'inv_12_dh_void_ability_sunder',
    maxRanks: 1,
    entryIds: [132284],
    definitionIds: [{ id: 137085, specId: 1480 }],
  },
  SOUL_BARRIER_TALENT: {
    id: 1265924,
    name: 'Soul Barrier',
    icon: 'inv_soulbarrier',
    maxRanks: 1,
    entryIds: [112870],
    definitionIds: [{ id: 117875, specId: 581 }],
  },
  SOUL_CARVER_TALENT: {
    id: 207407,
    name: 'Soul Carver',
    icon: 'inv_glaive_1h_artifactaldrochi_d_01',
    maxRanks: 1,
    entryIds: [112898],
    definitionIds: [{ id: 117903, specId: 581 }],
  },
  SOUL_CLEANSE_TALENT: {
    id: 1266496,
    name: 'Soul Cleanse',
    icon: 'spell_nature_removecurse',
    maxRanks: 1,
    entryIds: [136502],
    definitionIds: [{ id: 141275, specId: 1480 }],
  },
  SOUL_GLUTTON_TALENT: {
    id: 1247534,
    name: 'Soul Glutton',
    icon: 'ability_bossgorefiend_gorefiendscorruption',
    maxRanks: 1,
    entryIds: [134331],
    definitionIds: [{ id: 139103, specId: 1480 }],
  },
  SOUL_IMMOLATION_TALENT: {
    id: 1241937,
    name: 'Soul Immolation',
    icon: 'inv_12_dh_void_ability_voidpurge',
    maxRanks: 1,
    entryIds: [132286],
    definitionIds: [{ id: 137087, specId: 1480 }],
  },
  SOUL_RENDING_TALENT: {
    id: 204909,
    name: 'Soul Rending',
    icon: 'ability_demonhunter_soulcleave2',
    maxRanks: 2,
    entryIds: [112847],
    definitionIds: [{ id: 117852, specId: 1480 }],
  },
  SOUL_SIGILS_TALENT: {
    id: 395446,
    name: 'Soul Sigils',
    icon: 'ability_demonhunter_sigilofinquisition',
    maxRanks: 1,
    entryIds: [112869],
    definitionIds: [{ id: 117874, specId: 581 }],
  },
  SOUL_SPLITTER_TALENT: {
    id: 1266330,
    name: 'Soul Splitter',
    icon: 'ability_warlock_soulswap',
    maxRanks: 2,
    entryIds: [112862],
    definitionIds: [{ id: 117867, specId: 1480 }],
  },
  SPIRIT_BOMB_TALENT: {
    id: 247454,
    name: 'Spirit Bomb',
    icon: 'inv_icon_shadowcouncilorb_purple',
    maxRanks: 1,
    entryIds: [112907],
    definitionIds: [{ id: 117912, specId: 581 }],
    furyCost: 40,
  },
  SPONTANEOUS_IMMOLATION_TALENT: {
    id: 1246556,
    name: 'Spontaneous Immolation',
    icon: 'spell_fire_twilightimmolation',
    maxRanks: 1,
    entryIds: [135730],
    definitionIds: [{ id: 140485, specId: 1480 }],
  },
  STAR_FRAGMENTS_TALENT: {
    id: 1240204,
    name: 'Star Fragments',
    icon: 'inv_12_dh_void_ability_starfragments',
    maxRanks: 1,
    entryIds: [136697],
    definitionIds: [{ id: 141469, specId: 1480 }],
  },
  STATE_OF_MATTER_TALENT: {
    id: 1253402,
    name: 'State of Matter',
    icon: 'inv_112_arcane_buff',
    maxRanks: 1,
    entryIds: [135659],
    definitionIds: [{ id: 140415, specId: 1480 }],
  },
  STOKE_THE_FLAMES_TALENT: {
    id: 393827,
    name: 'Stoke the Flames',
    icon: 'ability_demonhunter_feldevastation',
    maxRanks: 1,
    entryIds: [112900],
    definitionIds: [{ id: 117905, specId: 581 }],
  },
  STUDENT_OF_SUFFERING_TALENT: {
    id: 452412,
    name: 'Student of Suffering',
    icon: 'achievement_dungeon_theatreofpain_kultharok',
    maxRanks: 1,
    entryIds: [117499, 136616],
    definitionIds: [
      { id: 122511, specId: 577 },
      { id: 141389, specId: 1480 },
    ],
  },
  SWALLOWED_ANGER_TALENT: {
    id: 320313,
    name: 'Swallowed Anger',
    icon: 'spell_misc_zandalari_council_soulswap',
    maxRanks: 1,
    entryIds: [112925],
    definitionIds: [{ id: 117930, specId: 1480 }],
  },
  SWEET_RELEASE_TALENT: {
    id: 1242768,
    name: 'Sweet Release',
    icon: 'spell_misc_zandalari_council_soulswap',
    maxRanks: 2,
    entryIds: [134149],
    definitionIds: [{ id: 138929, specId: 1480 }],
  },
  SWEET_SUFFERING_TALENT: {
    id: 1244295,
    name: 'Sweet Suffering',
    icon: 'ability_demonhunter_shatteredsouls',
    maxRanks: 2,
    entryIds: [132280],
    definitionIds: [{ id: 137081, specId: 1480 }],
  },
  SWIFT_ERASURE_TALENT: {
    id: 1253668,
    name: 'Swift Erasure',
    icon: 'ability_priest_darkarchangel',
    maxRanks: 1,
    entryIds: [135672],
    definitionIds: [{ id: 140428, specId: 1480 }],
  },
  TACTICAL_RETREAT_TALENT: {
    id: 389688,
    name: 'Tactical Retreat',
    icon: 'ability_demonhunter_vengefulretreat2',
    maxRanks: 1,
    entryIds: [112944],
    definitionIds: [{ id: 117949, specId: 577 }],
  },
  TEMPERED_SOUL_TALENT: {
    id: 1246555,
    name: 'Tempered Soul',
    icon: 'inv_12_dh_void_ability_voidpurge',
    maxRanks: 1,
    entryIds: [134280],
    definitionIds: [{ id: 139053, specId: 1480 }],
  },
  TEMPERED_STEEL_TALENT: {
    id: 1265800,
    name: 'Tempered Steel',
    icon: 'ability_demonhunter_manabreak',
    maxRanks: 1,
    entryIds: [112883],
    definitionIds: [{ id: 117888, specId: 581 }],
  },
  THE_HUNT_DEVOURER_TALENT: {
    id: 1246167,
    name: 'The Hunt',
    icon: 'inv_12_voiddh_ability_thehunt',
    maxRanks: 1,
    entryIds: [135736],
    definitionIds: [{ id: 140491, specId: 1480 }],
  },
  THE_HUNT_HAVOC_TALENT: {
    id: 370965,
    name: 'The Hunt',
    icon: 'inv_ability_demonhunter_thehunt',
    maxRanks: 1,
    entryIds: [112830],
    definitionIds: [{ id: 117835, specId: 577 }],
  },
  THRILL_OF_THE_FIGHT_TALENT: {
    id: 442686,
    name: 'Thrill of the Fight',
    icon: 'spell_arcane_arcanetactics',
    maxRanks: 1,
    entryIds: [117516],
    definitionIds: [{ id: 122528, specId: 581 }],
  },
  TRAIL_OF_RUIN_TALENT: {
    id: 258881,
    name: 'Trail of Ruin',
    icon: 'ability_demonhunter_bladedance',
    maxRanks: 1,
    entryIds: [112824],
    definitionIds: [{ id: 117829, specId: 577 }],
  },
  UMBRAL_BLADE_TALENT: {
    id: 1272842,
    name: 'Umbral Blade',
    icon: 'inv_12_dh_void_ability_reap',
    maxRanks: 1,
    entryIds: [133368],
    definitionIds: [{ id: 138154, specId: 1480 }],
  },
  UNBOUND_CHAOS_TALENT: {
    id: 347461,
    name: 'Unbound Chaos',
    icon: 'artifactability_vengeancedemonhunter_painbringer',
    maxRanks: 1,
    entryIds: [112942],
    definitionIds: [{ id: 117947, specId: 577 }],
  },
  UNDYING_EMBERS_TALENT: {
    id: 1272405,
    name: 'Undying Embers',
    icon: 'ability_warlock_burningembersgreen',
    maxRanks: 1,
    entryIds: [136032, 136609],
    definitionIds: [
      { id: 140787, specId: 577 },
      { id: 141382, specId: 1480 },
    ],
  },
  UNHINDERED_ASSAULT_TALENT: {
    id: 444931,
    name: 'Unhindered Assault',
    icon: 'ability_ironmaidens_bladerush',
    maxRanks: 1,
    entryIds: [123047],
    definitionIds: [{ id: 127928, specId: 581 }],
  },
  UNRESTRAINED_FURY_TALENT: {
    id: 320770,
    name: 'Unrestrained Fury',
    icon: 'ability_warrior_improveddisciplines',
    maxRanks: 1,
    entryIds: [112852],
    definitionIds: [{ id: 117857, specId: 1480 }],
  },
  UNTETHERED_FURY_TALENT: {
    id: 452411,
    name: 'Untethered Fury',
    icon: 'inv__felbarrage',
    maxRanks: 1,
    entryIds: [117501, 136606],
    definitionIds: [
      { id: 122513, specId: 577 },
      { id: 141379, specId: 1480 },
    ],
  },
  UNTETHERED_RAGE_1_VENGEANCE_TALENT: {
    id: 1270444,
    name: 'Untethered Rage',
    icon: 'inv12_apextalent_demonhunter__untetheredrage',
    maxRanks: 1,
    entryIds: [137043],
    definitionIds: [{ id: 141806, specId: 581 }],
  },
  UNTETHERED_RAGE_2_VENGEANCE_TALENT: {
    id: 1270448,
    name: 'Untethered Rage',
    icon: 'inv12_apextalent_demonhunter__untetheredrage',
    maxRanks: 2,
    entryIds: [137042],
    definitionIds: [{ id: 141805, specId: 581 }],
  },
  UNTETHERED_RAGE_3_VENGEANCE_TALENT: {
    id: 1270449,
    name: 'Untethered Rage',
    icon: 'inv12_apextalent_demonhunter__untetheredrage',
    maxRanks: 1,
    entryIds: [137041],
    definitionIds: [{ id: 141804, specId: 581 }],
  },
  VENGEFUL_BEAST_TALENT: {
    id: 1265818,
    name: 'Vengeful Beast',
    icon: 'inv12_ability_demonhunter_vengeanceismine',
    maxRanks: 1,
    entryIds: [112899],
    definitionIds: [{ id: 117904, specId: 581 }],
  },
  VENGEFUL_BONDS_TALENT: {
    id: 320635,
    name: 'Vengeful Bonds',
    icon: 'ability_demonhunter_vengefulretreat2',
    maxRanks: 1,
    entryIds: [112840],
    definitionIds: [{ id: 117845, specId: 1480 }],
  },
  VENGEFUL_RETREAT_TALENT: {
    id: 198793,
    name: 'Vengeful Retreat',
    icon: 'ability_demonhunter_vengefulretreat2',
    maxRanks: 1,
    entryIds: [112853],
    definitionIds: [{ id: 117858, specId: 1480 }],
  },
  VIOLENT_TRANSFORMATION_TALENT: {
    id: 452409,
    name: 'Violent Transformation',
    icon: 'spell_shadow_demoniccirclesummon',
    maxRanks: 1,
    entryIds: [117509, 136622],
    definitionIds: [
      { id: 122521, specId: 577 },
      { id: 141395, specId: 1480 },
    ],
  },
  VOIDBLADE_TALENT: {
    id: 1245412,
    name: 'Voidblade',
    icon: 'inv_12_voiddh_ability_voidblade',
    maxRanks: 1,
    entryIds: [134272],
    definitionIds: [{ id: 139045, specId: 1480 }],
  },
  VOIDFALL_TALENT: {
    id: 1253304,
    name: 'Voidfall',
    icon: 'inv_12_dh_void_ability_voidfall',
    maxRanks: 1,
    entryIds: [135667],
    definitionIds: [{ id: 140423, specId: 1480 }],
  },
  VOIDGLARE_BOON_TALENT: {
    id: 1240202,
    name: 'Voidglare Boon',
    icon: 'inv_nulllotus_cosmicvoid',
    maxRanks: 1,
    entryIds: [136694],
    definitionIds: [{ id: 141466, specId: 1480 }],
  },
  VOIDPURGE_TALENT: {
    id: 1244220,
    name: 'Voidpurge',
    icon: 'inv_12_dh_void_ability_voidray',
    maxRanks: 1,
    entryIds: [136699],
    definitionIds: [{ id: 141471, specId: 1480 }],
  },
  VOIDRAGE_TALENT: {
    id: 1242956,
    name: 'Voidrage',
    icon: 'inv_12_dh_void_ability_soulimmolation',
    maxRanks: 2,
    entryIds: [136131],
    definitionIds: [{ id: 140886, specId: 1480 }],
  },
  VOIDRUSH_TALENT: {
    id: 1272422,
    name: 'Voidrush',
    icon: 'inv_12_dh_void_ability_voidstep',
    maxRanks: 1,
    entryIds: [136698],
    definitionIds: [{ id: 141470, specId: 1480 }],
  },
  VOIDSURGE_TALENT: {
    id: 452402,
    name: 'Voidsurge',
    icon: 'inv_ability_felscarreddemonhunter_demonsurge',
    maxRanks: 1,
    entryIds: [136613],
    definitionIds: [{ id: 141386, specId: 1480 }],
  },
  VOID_METAMORPHOSIS_TALENT: {
    id: 471306,
    name: 'Void Metamorphosis',
    icon: 'inv_112_ability_demonhunter_metamorphasisvoid',
    maxRanks: 1,
    entryIds: [132282],
    definitionIds: [{ id: 137083, specId: 1480 }],
  },
  VOID_NOVA_TALENT: {
    id: 1234195,
    name: 'Void Nova',
    icon: 'inv_12_voiddh_ability_voidnova',
    maxRanks: 1,
    entryIds: [132289],
    definitionIds: [{ id: 137090, specId: 1480 }],
  },
  VOID_RAY_TALENT: {
    id: 473728,
    name: 'Void Ray',
    icon: 'inv_12_dh_void_ability_voidray',
    maxRanks: 1,
    entryIds: [132278],
    definitionIds: [{ id: 137079, specId: 1480 }],
    furyCost: 100,
  },
  VOID_REAVER_TALENT: {
    id: 268175,
    name: 'Void Reaver',
    icon: 'spell_shadow_demonicempathy',
    maxRanks: 1,
    entryIds: [112890],
    definitionIds: [{ id: 117895, specId: 581 }],
  },
  VOLATILE_FLAMEBLOOD_TALENT: {
    id: 390808,
    name: 'Volatile Flameblood',
    icon: 'ability_demonhunter_immolation',
    maxRanks: 1,
    entryIds: [112902],
    definitionIds: [{ id: 117907, specId: 581 }],
  },
  VOLATILE_INSTINCT_TALENT: {
    id: 1272453,
    name: 'Volatile Instinct',
    icon: 'inv_nature_nova',
    maxRanks: 1,
    entryIds: [136030, 136611],
    definitionIds: [
      { id: 140785, specId: 577 },
      { id: 141384, specId: 1480 },
    ],
  },
  VULNERABILITY_TALENT: {
    id: 389976,
    name: 'Vulnerability',
    icon: 'inv_icon_shadowcouncilorb_purple',
    maxRanks: 2,
    entryIds: [112897],
    definitionIds: [{ id: 117902, specId: 581 }],
  },
  WARBLADES_HUNGER_TALENT: {
    id: 442502,
    name: "Warblade's Hunger",
    icon: 'ability_warlock_soulsiphon',
    maxRanks: 1,
    entryIds: [136027],
    definitionIds: [{ id: 140782, specId: 581 }],
  },
  WASTE_NOT_TALENT: {
    id: 1223918,
    name: 'Waste Not',
    icon: 'inv_12_dh_void_ability_wastenot',
    maxRanks: 1,
    entryIds: [133370],
    definitionIds: [{ id: 138156, specId: 1480 }],
  },
  WAVE_OF_DEBILITATION_TALENT: {
    id: 452403,
    name: 'Wave of Debilitation',
    icon: 'spell_fire_felfirenova',
    maxRanks: 1,
    entryIds: [117510, 136621],
    definitionIds: [
      { id: 122522, specId: 577 },
      { id: 141394, specId: 1480 },
    ],
  },
  WILL_OF_THE_ILLIDARI_TALENT: {
    id: 389695,
    name: 'Will of the Illidari',
    icon: 'ability_demonhunter_spectank',
    maxRanks: 2,
    entryIds: [112918],
    definitionIds: [{ id: 117923, specId: 1480 }],
  },
  WINGS_OF_WRATH_TALENT: {
    id: 1266493,
    name: 'Wings of Wrath',
    icon: 'ability_demonhunter_glide',
    maxRanks: 1,
    entryIds: [136500],
    definitionIds: [{ id: 141273, specId: 1480 }],
  },
  WORLD_KILLER_TALENT: {
    id: 1256353,
    name: 'World Killer',
    icon: 'inv_112_raiddimensius_brokenworld',
    maxRanks: 1,
    entryIds: [135660],
    definitionIds: [{ id: 140416, specId: 1480 }],
  },
  WOUNDED_QUARRY_TALENT: {
    id: 442806,
    name: 'Wounded Quarry',
    icon: 'ability_rogue_venomouswounds',
    maxRanks: 1,
    entryIds: [117494],
    definitionIds: [{ id: 122506, specId: 581 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_DEMON_HUNTER };
